<template>
    <div class="videoList videoListSlider col-12">
        <carousel 
            ref="VideoListCarousel"
            v-model="currentVideoListSlide" 
            v-bind="currentVideoListSettings" 
            :breakpoints="currentVideoListBreakpoints"
            :transition="500"
            :wrap-around="true"
            >

            <slide v-for="(single, idx) in videoObject" :key="'globalVideoListSingle_' + idx" >
                <video :title="this.getVideoTitle(single)"  :tabindex="isActive ? 0 : -1" width="100%" height="480" ref="videoListSliderSingle" controls poster="@/assets/dist/img/poster.png">
                    <source :src="single.url" type="video/mp4">
                    <track default kind="captions" :srclang="this.$store.state.lang" :src="this.getVideoSubtitles(single)" />
                    Your browser does not support the video tag.
                </video>
            </slide>
            
            <template #addons>
                <!-- <navigation /> -->
                <pagination />
            </template>
        </carousel>

        <div class="videoListSliderNav">
            <button role="button" 
                @keydown.space.prevent="prev"
                @keydown.enter.prevent="prev"
                @click.stop.prevent="prev"><span class='icon icon-prev'></span></button>
            <!-- <input type="number" min="0" max="9" v-model="currentSlide" /> -->
            <!-- <div>{{ currentSlide }}</div> -->
            <button role="button" 
                @keydown.space.prevent="next"
                @keydown.enter.prevent="next"
                @click.stop.prevent="next"><span class='icon icon-next'></span></button>
        </div>
    </div>
</template>

<script>
// import { defineComponent } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination } from 'vue3-carousel';

export default {
    name: 'VideoListSlider',
    data() {
        return {
            // carousel settings
            // caption: '/img/video_caption.vtt',

            currentVideoListSlide: 0,
            currentVideoListSettings: {
                itemsToShow: 1,
                snapAlign: 'start',
            },
            currentVideoListBreakpoints: {
                390: {
                    itemsToShow: 1,
                    snapAlign: 'start',
                },
                // 768: {
                //     itemsToShow: 1,
                //     snapAlign: 'start',
                // },
                // 1024: {
                //     itemsToShow: 3,
                //     snapAlign: 'start',
                // },
            },
            // carousel settings
        }
    },
    components: {
        Carousel,
        Slide,
        Pagination,
    },
    props: {
        videoObject: {type: Array}
    },
    methods: {
        next() {
            this.$refs.VideoListCarousel.next()
        },
        prev() {
            this.$refs.VideoListCarousel.prev()
        },
        getVideoTitle(el) {
            if(this.$store.state.lang == 'en')
                return el.headlineEn;
            else if(this.$store.state.lang == 'uk')
                return el.headlineUk;

            return el.headline;
        },
        getVideoSubtitles(el) {
            if(this.$store.state.lang == 'en')
                return el.subtitlesEn;
            else if(this.$store.state.lang == 'uk')
                return el.subtitlesUk;

            return el.subtitles;
        },
        // handleProgress() {
        //     var percent = (this.$refs['videoListSliderSingle'].currentTime / this.$refs['videoListSliderSingle'].duration) * 100;
        //     console.log('videoListSliderSingle', percent);
        // },
    }
};
</script>